<script setup>
    const props = defineProps({
        buttons: {
            type: Array,
            default: [
                // {
                //     type: 'submit',
                //     color: 'primary',
                //     text: 'Save'
                //     name: 'close'
                // },
                { text: 'Close', dismiss: 'modal' }
            ]
        }
    });
</script>

<template>
    <div class="modal-footer">
        <button
            v-for="button of buttons"
            :type="button.type ?? 'button'"
            class="btn"
            :class="button.color ? `btn-${button.color}` : 'btn-secondary'"
            :name="button.name"
            :data-bs-dismiss="button.dismiss ? 'modal' : null">
            {{ button.text }}
        </button>
    </div>
</template>

<script>
    export default {
        name: 'ModalFooter'
    };
</script>
